import React, { useState, useEffect } from 'react'
import PlayerHistoryHomeNavigation from './PlayerHistoryHomeNavigation'
import './StatsAndStandingsHome.css'
import Footer from '../UIElements/Footer'
import Banner from './Banner'
import logo from '../../../images/CHE-logo-x2.png'
import SearchForPlayer from '../UIElements/SearchForPlayer'

const PlayerStatsHome = () => {
	const [isMobile, setIsMobile] = useState(window.innerWidth <= 440)

	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth <= 440)
		}

		window.addEventListener('resize', handleResize)

		return () => window.removeEventListener('resize', handleResize)
	}, [])

	return (
		<div className='page-wrapper playerStatsHome'>
			<PlayerHistoryHomeNavigation />

			{!isMobile && (
				<div className='playerStatsHome__banner'>
					<Banner />
				</div>
			)}

			<main className='page-content playerStatsHome__content'>
				<div className='playerStatsHome__inner'>
					<h1 className='playerStatsHome__title'>FIND A PLAYER</h1>

					<div className='playerStatsHome__divider'>
						<span></span>

						<img
							src={logo}
							alt='Cool Hockey Events'
							className='playerStatsHome__dividerLogo'
						/>

						<span></span>
					</div>

					<p className='playerStatsHome__description'>
						Search for any player to view their history, teams, and career
						stats.
					</p>

					<div className='playerStatsHome__searchCard'>
						<div className='playerStatsHome__searchHeading'>
							<div className='playerStatsHome__searchIcon'>⌕</div>

							<div>
								<strong>To find a player's page,</strong>
								<span>start typing their last name:</span>
							</div>
						</div>

						<div className='playerStatsHome__search'>
							<SearchForPlayer />
						</div>
					</div>
				</div>
			</main>

			<Footer />
		</div>
	)
}

export default PlayerStatsHome
